import React from "react";

function PageWrap({ title, lead, children }) {
    return (
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
            <p className="md-overline">Mission Dresseur</p>
            <h1 className="md-h2 mt-2 text-md-text">{title}</h1>
            {lead && <p className="mt-4 text-base leading-relaxed text-md-text-2">{lead}</p>}
            <div className="prose prose-sm mt-8 max-w-none text-md-text-2 [&_h2]:mt-10 [&_h2]:text-md-text [&_h2]:font-semibold [&_h2]:text-xl [&_strong]:text-md-text">
                {children}
            </div>
        </div>
    );
}

export function CommentCaMarche() {
    return (
        <PageWrap
            title="Comment ça marche"
            lead="Un acheteur confie une mission. Un dresseur fouille ses doubles. Les cartes retrouvées avancent un classeur."
        >
            <h2>1 · Tu prépares ta mission</h2>
            <p>Choisis ton TCG, le set qui t’intéresse, et marque tes cartes : <strong>J’ai</strong>, <strong>Manquant</strong>, ou <strong>Je ne sais pas</strong>. Les manquantes alimentent la mission.</p>
            <h2>2 · Tu lances ta mission</h2>
            <p>Une mission lancée est figée — c’est ce qui protège le temps des dresseurs. Tu peux continuer à explorer tant qu’aucun dresseur ne l’a prise.</p>
            <h2>3 · Un dresseur prend la mission</h2>
            <p>Il a l’exclusivité, fouille ses doubles, prépare ses photos, t’envoie une proposition claire avec le détail par rareté.</p>
            <h2>4 · Tu valides, tu reçois, tu valides la réception</h2>
            <p>Le suivi La Poste te tient au courant. Quand tu reçois, tu valides. Le dresseur est payé sur son solde Mission Dresseur.</p>
        </PageWrap>
    );
}

export function DevenirDresseur() {
    return (
        <PageWrap
            title="Devenir dresseur certifié"
            lead="Pas un simple formulaire. Une vraie épreuve de sélection culturelle."
        >
            <h2>Une mission test</h2>
            <p>On te propose une mini-mission : quelques COUNCO, des reverses, des holos, un ex/V. Tu prépares, tu photographies, tu réponds aux questions.</p>
            <h2>Une charte d’engagement</h2>
            <p>Cartes propres pour binder, préparation sérieuse, expédition rapide, numéro de suivi valide. Un faux suivi = exclusion immédiate.</p>
            <h2>Une validation manuelle</h2>
            <p>L’équipe Mission Dresseur valide manuellement en V1. Si refus, c’est un statut à améliorer, pas une humiliation : tu peux refaire tes photos, relire la charte, et représenter ta candidature.</p>
        </PageWrap>
    );
}

export function Charte() {
    return (
        <PageWrap title="Charte du dresseur" lead="Le contrat moral entre les dresseurs et la plateforme.">
            <ul className="list-disc space-y-2 pl-5">
                <li>Cartes <strong>propres pour binder</strong> — Near Mint visible.</li>
                <li>Préparation sérieuse — sleeves, top-loader léger, enveloppe bulle.</li>
                <li>Expédition rapide — sous 72h après acceptation.</li>
                <li>Numéro de suivi <strong>valide et unique</strong>.</li>
                <li>Communication via les workflows guidés — pas de messagerie libre.</li>
                <li>Faux suivi = exclusion immédiate et solde gelé.</li>
            </ul>
        </PageWrap>
    );
}

export function FAQ() {
    const qa = [
        { q: "Est-ce une marketplace ?", a: "Non. C’est une plateforme qui organise des missions de recherche. Tu ne navigues pas dans un catalogue de cartes en vente." },
        { q: "Puis-je négocier le prix ?", a: "Non. Les prix sont fixés par la plateforme, par bloc et par rareté. Tu raisonnes en mission globale." },
        { q: "Qui gère les litiges ?", a: "Des workflows guidés — pas de chat libre. Cartes manquantes, colis perdu, suivi suspect : tout est cadré." },
        { q: "Quels jeux sont supportés ?", a: "V1 = Pokémon FR. L’architecture est multi-TCG dès le départ, d’autres jeux et langues suivront." },
        { q: "Comment je suis payé en tant que dresseur ?", a: "Sur un solde Mission Dresseur, après réception confirmée par l’acheteur (ou auto-validation après délai). Aucun minimum de retrait en V1." },
    ];
    return (
        <PageWrap title="FAQ" lead="Les questions qu’on nous pose le plus souvent.">
            <div className="not-prose space-y-3">
                {qa.map((it, i) => (
                    <details key={i} className="group rounded-xl border border-md-border bg-md-surface p-4">
                        <summary className="cursor-pointer list-none font-semibold text-md-text">
                            <span className="mr-2 text-md-secondary">Q.</span>{it.q}
                        </summary>
                        <p className="mt-2 text-sm leading-relaxed text-md-text-2">{it.a}</p>
                    </details>
                ))}
            </div>
        </PageWrap>
    );
}

export function CGU() {
    return (
        <PageWrap title="Conditions générales d’utilisation" lead="Version provisoire — Phase 1. Sera révisée avant ouverture large.">
            <p>Les présentes CGU régissent l’usage de Mission Dresseur. Le contenu détaillé sera publié avant la phase d’ouverture publique. La plateforme agit comme intermédiaire : les vendeurs sont des particuliers, Mission Dresseur facture une participation de service pour organiser la mission.</p>
        </PageWrap>
    );
}

export function Confidentialite() {
    return (
        <PageWrap title="Politique de confidentialité" lead="Version provisoire — Phase 1.">
            <p>Mission Dresseur traite les données personnelles dans le cadre du RGPD. Les détails complets (finalités, durées, droits) seront publiés avant ouverture publique.</p>
        </PageWrap>
    );
}

export function MentionsLegales() {
    return (
        <PageWrap title="Mentions légales" lead="Version provisoire — Phase 1.">
            <p>Éditeur : Mission Dresseur. Hébergeur : Emergent / Kubernetes. Les mentions légales détaillées seront publiées avant ouverture publique.</p>
        </PageWrap>
    );
}
